import React, {Component, FC, ReactElement, useEffect, useState, useRef} from 'react';
import './RKPI.scss';
import styled from 'styled-components';
import FlipNumbers from 'react-flip-numbers';


type rkpiProps = {
    fontSize: string,
    color: string,
    number: number,
    prefix: string | null,
    suffix: string | null,
    speed: string,
    horizontalAlignment: string,
    isBold:boolean,
    anchorName:string,
    anchorTrigger:string
}

type RkpiWrapperProps = {
    horizontalAlignment: string,
    color: string,
    fontSize: string,
    isBold:boolean
}

type rkpiElementProps = {

}

const RkpiWrapper = styled.div<RkpiWrapperProps>`
&.rkpi {
   justify-content: ${props => props.horizontalAlignment || 'inherit'};
   ${props => props.horizontalAlignment === 'start' && `
        text-align:left;
    `}; 
    ${props => props.horizontalAlignment === 'center' && `
        text-align:center;
    `}; 
     ${props => props.horizontalAlignment === 'end' && `
        text-align:right;
    `}; 
    color: ${props => props.color || 'inherit'};
    font-size: ${props => props.fontSize + 'px' || 'inherit'};
    * {
        color: ${props => props.color || 'inherit'} !important;
        font-weight: ${props => props.isBold ? 'bold' : 'inherit'};
        width: auto !important;
        min-width: ${props => Number(props.fontSize)/1.6 + 'px' || '0'};
    }
    font-weight: ${props => props.isBold ? 'bold' : 'inherit'};
}
`;

const RKPIElement = styled.div<rkpiElementProps>`

`;

const RKPI: FC<rkpiProps> = ({...props}): ReactElement => {

    const rkpiElement = useRef<any>(null);
    const [play, setPlay] = useState(false);

    let duration = getSpeed();

    function getSpeed() {
        switch (props.speed) {
            case 'slow':
                return 4;
            case 'medium':return 2;
            case 'fast':return 0.5;
            default: return 2;
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleRKPIPlugin);
    },[])

    function handleRKPIPlugin() {
        if(!rkpiElement || !rkpiElement.current) return;
        let isInView = isScrolledIntoView(rkpiElement.current);
        if (!isInView) return;
        setTimeout(()=>{setPlay(true)}, 200)
    }

    function isScrolledIntoView(el: any) {
        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.scrollY + window.innerHeight) &&
            left < (window.scrollY + window.innerWidth) &&
            (top + height) > window.scrollY &&
            (left + width) > window.scrollX
        );
    }

    return (
        <RkpiWrapper className={'rkpi'} horizontalAlignment={props.horizontalAlignment} color={props.color} fontSize={props.fontSize} isBold={props.isBold}>
            {props.prefix}
            <RKPIElement className="number" ref={rkpiElement}>
                <FlipNumbers height={Number(props.fontSize)} width={Number(props.fontSize)} color={props.color} play={play} perspective={1000}
                             duration={duration} numbers={props.number.toString()}/>
            </RKPIElement>
            {props.suffix}
        </RkpiWrapper>
    );
};

let fontSizeValues = [];
for (let i = 0; i < 152; i++) {
    if (i !== 0 && i > 9 && i % 2 == 0) {
        fontSizeValues.push(i);
    }
}

let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [
            {
                settingName: 'FontSize',
                controls: [
                    {
                        controlName: 'InputSelect',
                        property: 'fontSize',
                        title: '',
                        defaultValue: '14',
                        values: fontSizeValues
                    },
                ],
            },
            {
                settingName: 'Bold',
            },
            {
                settingName: 'TitleColor'
            },
        ],
        [
            {
                settingName: 'RkpiNumber',
                title: 'Number',
                isShowTitle: false,
                icon: environmentLink + '/assets/images/RKPi.svg',
                hasDrop: true,
                dropWidth: 'medium',
                controls: [
                    {
                        controlName: 'InputNumber',
                        property: 'number',
                        title: 'Number',
                        defaultValue: 0,
                        min: 0,
                        max: 10000000000000,
                        hideArrows: true
                    },
                ]
            },
            {
                settingName: 'RkpiPreAndSuff',
                title: 'Prefix and Suffix',
                icon: environmentLink + '/assets/images/rkpiPreSuf.svg',
                hasDrop: true,
                dropWidth: 'medium',
                controls: [
                    {
                        controlName: 'InputText',
                        property: 'prefix',
                        title: 'Prefix',
                        defaultValue: 'Type your prefix here...',
                        separateLine: true,
                        padding: '16px',
                        margin: '0'
                    },
                    {
                        controlName: 'InputText',
                        property: 'suffix',
                        title: 'Suffix',
                        defaultValue: 'Type your suffix here...',
                        separateLine: true,
                        padding: '16px',
                        margin: '0'
                    },
                ],
                removePadding: true
            },
            {
                settingName: 'Speed'
            }
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const options = [
    {
        name:'edit',
        title: 'Change number',
        icon: environmentLink + '/assets/images/Options/rkpi.svg',
        action: 'setActiveSetting',
        settingTitle: 'Number'
    },
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveSetting',
        settingTitle: 'Font size'
    }
]

export default {
    RKPI,
    settings,
    options,
    label: 'Animated number'
};



